import {
  TRAVELTIME_ISOCHRONE_MAX_RINGS,
  TRAVELTIME_ISOCHRONE_RINGS,
  type TraveltimeIsochroneRings,
  type TraveltimeRing,
} from "@/v2-ui/icon/custom/traveltimeIsochrone/traveltimeIsochrone.constants"

export type { TraveltimeRing }
/** How many rings a start point can wear: one per search, up to four, as the reach glyph. */
export type TraveltimeStartPointRings = TraveltimeIsochroneRings
export const TRAVELTIME_START_POINT_MAX_RINGS: TraveltimeStartPointRings =
  TRAVELTIME_ISOCHRONE_MAX_RINGS

/** The isochrone rings behind a start point: the reach glyph's own, so the two families stay in step. */
export const TRAVELTIME_START_POINT_RINGS = TRAVELTIME_ISOCHRONE_RINGS

/** The pin: its ground dot, body and hole, on the same 32×32 grid, point at (16, 16). */
export const TRAVELTIME_START_POINT_PIN_DOT_PATH =
  "M16.0001 17.9001C17.0494 17.9001 17.9001 17.0494 17.9001 16.0001C17.9001 14.9508 17.0494 14.1001 16.0001 14.1001C14.9508 14.1001 14.1001 14.9508 14.1001 16.0001C14.1001 17.0494 14.9508 17.9001 16.0001 17.9001Z"
export const TRAVELTIME_START_POINT_PIN_BODY_PATH =
  "M21.5999 6.47012C21.5999 9.96522 17.7226 13.6052 16.4206 14.7294C16.2993 14.8206 16.1517 14.8699 15.9999 14.8699C15.8481 14.8699 15.7005 14.8206 15.5792 14.7294C14.2772 13.6052 10.3999 9.96522 10.3999 6.47012C10.3999 4.98491 10.9899 3.56052 12.0401 2.51032C13.0903 1.46012 14.5147 0.870117 15.9999 0.870117C17.4851 0.870117 18.9095 1.46012 19.9597 2.51032C21.0099 3.56052 21.5999 4.98491 21.5999 6.47012Z"
export const TRAVELTIME_START_POINT_PIN_HOLE_PATH =
  "M15.9999 8.57012C17.1597 8.57012 18.0999 7.62992 18.0999 6.47012C18.0999 5.31032 17.1597 4.37012 15.9999 4.37012C14.8401 4.37012 13.8999 5.31032 13.8999 6.47012C13.8999 7.62992 14.8401 8.57012 15.9999 8.57012Z"

/**
 * The pin follows the theme, not the search colour: a dark pin with a pale
 * outline on light, a pale pin with a dark outline on dark. The theme's own
 * foreground and background tokens give exactly that swap.
 */
export const TRAVELTIME_START_POINT_PIN_FILL = "hsl(var(--foreground))"
export const TRAVELTIME_START_POINT_PIN_OUTLINE = "hsl(var(--background))"
